<div class="input-autocomplete-container">
  <div class="input-autocomplete__trigger">
    <qr-input
      [config]="config"
      (valueChange)="inputChange($event)"
      [(value)]="selectedOption"
      [isDisabled]="isDisabled"
      [hasError]="hasError"
      (blurChange)="blurChange.emit(true)"
    ></qr-input>
  </div>

  <div
    class="options"
    [ngClass]="{ show: noResults && !isLoading }"
    [class.options--multiline]="multilineAddressOptions"
  >
    <span class="option subheading-01-semi-bold">
      No se encontraron resultados
    </span>
  </div>

  <div
    class="options"
    [ngClass]="{ show: isOptionsVisible }"
    [class.options--multiline]="multilineAddressOptions"
  >
    <!-- LOADER -->
    <div class="loader-container" *ngIf="isLoading">
      <div class="loader"></div>
    </div>

    <!-- LISTADO -->
    <span
      class="option subheading-01-semi-bold"
      *ngFor="let option of listResponse"
      [class.option--multiline]="multilineAddressOptions"
      matRipple
      (click)="select(option)"
      [title]="option"
    >
      {{ option }}
    </span>
  </div>
</div>
